import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  error: string;
  onRetry?: () => void;
  isRetrying?: boolean;
}

export function ErrorModal({ isOpen, onClose, error, onRetry, isRetrying = false }: ErrorModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Error
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {error}
          </p>
        </div>

        <div className="flex gap-2 pt-4">
          {onRetry && (
            <Button
              onClick={onRetry}
              disabled={isRetrying}
              variant="default"
              className="flex-1"
            >
              {isRetrying ? (
                <>
                  <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                  Retrying...
                </>
              ) : (
                <>
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Retry
                </>
              )}
            </Button>
          )}
          <Button variant="outline" onClick={onClose} className={onRetry ? "flex-1" : "w-full"}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}